import React, { useEffect, useState } from 'react';
import { MetaTags } from 'react-meta-tags';
import { DashBreadcrumb } from '../../components/Common/Breadcrumb';
import {
  Container,
  Row,
  Col,
  Card,
  FormGroup,
  CardBody,
  CardTitle,
  CardHeader,
  Spinner,
  Collapse,
  Label,
} from 'reactstrap';
import CustomRichTextEditor from './CustomRichTextEditor';
import { AvForm, AvField } from 'availity-reactstrap-validation';
import { CreateNewStore } from './action/action';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import toast, { Toaster } from 'react-hot-toast';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import classnames from 'classnames';

const ClickandCollect = () => {
  const history = useHistory();
  const [col1, setcol1] = useState(true);
  const [col2, setcol2] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [storeStatus, setStoreStatus] = useState(false);
  const [isClickAndCollect, setIsClickAndCollect] = useState(false);
  const [showSalesBanner, setShowSalesBanner] = useState(false);
  const [desContentEn, setDescriptionContentEn] = useState('');
  const [desContentAr, setDescriptionContentAr] = useState('');
  const [bookAnAppointment, setBookAnAppointment] = useState(false);
  const [showSalesBannerPosition, setShowSalesBannerPosition] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const t_col1 = () => {
    setcol1(!col1);
    setcol2(false);
  };
  const t_col2 = () => {
    setcol2(!col2);
    setcol1(false);
  };
  const updateArticleContentEn = (e) => {
    setDescriptionContentEn(e);
  };
  const updateArticleContentAr = (e) => {
    setDescriptionContentAr(e);
  };
  const dispatch = useDispatch();

  const CreateNewStoreData = (events, values) => {
    setIsLoading(true);
    const StoreName_en = values?.stName_en ? values?.stName_en : '';
    const StoreName_ar = values?.stName_ar ? values?.stName_ar : '';
    const address_en = values?.address_en ? values?.address_en : '';
    const address_ar = values?.address_ar ? values?.address_ar : '';
    const shortDescription_en = values?.shortDec_en ? values?.shortDec_en : '';
    const shortDescription_ar = values?.storeDec_ar ? values?.storeDec_ar : '';
    const image = values?.image ? values?.image : '';
    const region = values?.region ? values?.region : '';
    const city = values?.city ? values?.city : '';
    const longitude = values?.longitude ? values?.longitude : '';
    const latitude = values?.latitude ? values?.latitude : '';
    const sortOrder = values?.sortOrder ? values?.sortOrder : '';
    const fullfillmentDays = values?.fulfillmentDay
      ? values?.fulfillmentDay
      : '';
    const storeEmailId = values?.email ? values?.email : '';
    const telephone1 = values?.telephone1 ? values?.telephone1 : '';
    const telephone2 = values?.telephone2 ? values?.telephone2 : '';
    const placeID = values?.placeID ? values?.placeID : '';
    const storeCode = values?.storcode ? values?.storcode : '';
    const storeUrlKey = values?.storeUrlKey ? values?.storeUrlKey : '';
    const timing_en = values?.storeTiming_en ? values?.storeTiming_en : '';
    const timing_ar = values?.storeTiming_ar ? values?.storeTiming_ar : '';
    const appointmentURL = values?.appointmentURL ? values?.appointmentURL : '';
    const metaTitle_en = values?.metaTitle_en ? values?.metaTitle_en : '';
    const metaTitle_ar = values?.metaTitle_ar ? values?.metaTitle_ar : '';
    const metaDescription_en = values?.metaDescription_en
      ? values?.metaDescription_en
      : '';
    const metaDescription_ar = values?.metaDescription_ar
      ? values?.metaDescription_ar
      : '';
    const data = {
      country: selectedCountry,
      storeName: { en: StoreName_en, ar: StoreName_ar },
      address: { en: address_en, ar: address_ar },
      shortDescription: { en: shortDescription_en, ar: shortDescription_ar },
      description: { en: desContentEn, ar: desContentAr },
      image: image,
      region: region,
      city: city,
      longitude: longitude,
      latitude: latitude,
      sortOrder: sortOrder,
      fullfillmentDays: fullfillmentDays,
      storeEmailId: storeEmailId,
      telephone1: telephone1,
      telephone2: telephone2,
      PlaceID: placeID,
      storeCode: storeCode,
      storeUrlKey: storeUrlKey,
      offerBannerPosition: showSalesBannerPosition,
      isClickCollect: isClickAndCollect === 'true' ? true : false,
      isDisplayInForm: storeStatus === 'true' ? true : false,
      showSaleBanner: showSalesBanner === 'true' ? true : false,
      bookAnAppointment: bookAnAppointment === 'true' ? true : false,
      appointmentURL: appointmentURL,
      timing1: { en: timing_en, ar: timing_ar },
      metaTitle: { en: metaTitle_en, ar: metaTitle_ar },
      metaDescription: { en: metaDescription_en, ar: metaDescription_ar },
    };

    CreateNewStore({ data, dispatch });
  };

  const { store = [], isStoreLoading } = useSelector(
    (state) => state.permissions
  );
  useEffect(() => {
    if (store?.code === 200) {
      setIsLoading(false);
      toast.success(store?.message, {
        style: {
          border: '1px solid #fff',
          padding: '20px',
          color: '#ffffff',
          background: '#4CAF50',
        },
        iconTheme: {
          primary: '#FFFAEE',
          secondary: '#4CAF50',
        },
      });
      setTimeout(() => {
        history.push('/ClickandCollectList');
      }, 10);
    } else {
      if (store?.code === 400) {
        setIsLoading(false);
        toast.error('Create store error', {
          style: {
            border: '1px solid #fff',
            padding: '20px',
            color: '#ffffff',
            background: '#f44336',
          },
          iconTheme: {
            primary: '#FFFAEE',
            secondary: '#f44336',
          },
        });
      }
    }
  }, [store]);

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Click & Collect </title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Row>
            <Col xl={11}>
              <DashBreadcrumb
                title="Click & Collect Store"
                breadcrumbItem="Click & Collect"
              />
            </Col>
          </Row>

          <Row>
            <Col xl={12}>
              <AvForm
                className="needs-validation"
                onValidSubmit={(e, v) => {
                  CreateNewStoreData(e, v);
                }}
              >
                <CardHeader>
                  <Row>
                    <Col xl={11}>
                      <CardTitle>Danubehome - Dubai Barsha Store</CardTitle>
                    </Col>
                    <Col>
                      <button
                        type="submit"
                        className="btn btn-dark"
                        data-toggle="modal"
                      >
                        {isLoading === true && (
                          <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        )}{' '}
                        Submit
                      </button>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  <div className="accordion" id="accordion">
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingOne">
                        <button
                          className={classnames(
                            'accordion-button',
                            'fw-medium',

                            { collapsed: !col1 }
                          )}
                          type="button"
                          onClick={t_col1}
                          style={{ cursor: 'pointer' }}
                        >
                          General Information
                        </button>
                      </h2>

                      <Collapse isOpen={col1} className="accordion-collapse">
                        <div className="accordion-body">
                          <div className="text-muted">
                            <Row
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'center',
                              }}
                            >
                              <Col lg={9}>
                                <Card>
                                  <CardBody>
                                    <Row>
                                      <Col md="6">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor="validationCustom01">
                                            Store Name - English
                                          </Label>
                                          <AvField
                                            name="stName_en"
                                            type="text"
                                            errorMessage="Enter store Name"
                                            className="form-control"
                                            validate={{
                                              required: { value: true },
                                            }}
                                            id="validationCustom01"
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col md="6">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor="validationCustom01">
                                            Store Name - Arabic
                                          </Label>
                                          <AvField
                                            name="stName_ar"
                                            type="text"
                                            errorMessage="Enter store Name"
                                            className="form-control"
                                            validate={{
                                              required: { value: true },
                                            }}
                                            id="validationCustom01"
                                          />
                                        </FormGroup>
                                      </Col>

                                      <Col md="6">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor="validationCustom01">
                                            Store Code
                                          </Label>
                                          <AvField
                                            name="storcode"
                                            placeholder="Type Something"
                                            type="text"
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col lg="6">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor="validationCustom01">
                                            Country
                                          </Label>
                                          <select
                                            className="form-control"
                                            name="website_id"
                                            id="choices-single-no-search"
                                            onChange={(e) => {
                                              setSelectedCountry(
                                                e.target.value
                                              );
                                            }}
                                          >
                                            <option value="ae">Select</option>
                                            <option value="ae">UAE</option>
                                            <option value="om">Oman</option>
                                            <option value="bh">Bahrain</option>
                                            <option value="qa">Qatar</option>
                                          </select>
                                        </FormGroup>
                                      </Col>
                                      <Col md="6">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor="validationCustom01">
                                            Email
                                          </Label>
                                          <AvField
                                            name="email"
                                            type="email"
                                            errorMessage="Enter Email"
                                            validate={{
                                              required: { value: true },
                                            }}
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col md="6">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor="validationCustom01">
                                            Telephone1
                                          </Label>
                                          <AvField
                                            name="telephone1"
                                            type="text"
                                            errorMessage="Enter Store Phone No"
                                            validate={{
                                              required: { value: true },
                                            }}
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col md="6">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor="validationCustom01">
                                            Telephone2
                                          </Label>
                                          <AvField
                                            name="telephone2"
                                            type="text"
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col md="6">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor="validationCustom01">
                                            Latitude
                                          </Label>
                                          <AvField
                                            name="latitude"
                                            type="text"
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col md="6">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor="validationCustom01">
                                            Longitude
                                          </Label>
                                          <AvField
                                            name="longitude"
                                            type="text"
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col md="6">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor="validationCustom01">
                                            Place ID
                                          </Label>
                                          <AvField
                                            name="placeID"
                                            type="text"
                                            errorMessage=" Enter the Place ID"
                                            validate={{
                                              required: { value: true },
                                            }}
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col md="6">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor="validationCustom01">
                                            Sort Order
                                          </Label>
                                          <AvField
                                            name="sortOrder"
                                            type="Number"
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col md="6">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor="validationCustom01">
                                            Display Inquiry Forms
                                          </Label>
                                          <select
                                            className="form-control"
                                            name="storeStatus"
                                            id="choices-single-no-search"
                                            onChange={(e) => {
                                              setStoreStatus(e.target.value);
                                            }}
                                          >
                                            <option value="">Select</option>
                                            <option value={true}>Active</option>
                                            <option value={false}>
                                              InActive
                                            </option>
                                          </select>
                                        </FormGroup>
                                      </Col>
                                      <Col md="6">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor="validationCustom01">
                                            Fullfillment Days
                                          </Label>
                                          <AvField
                                            name="fulfillmentDay"
                                            placeholder="Type Something"
                                            type="text"
                                            errorMessage="Please write the fullfillment Days"
                                            validate={{
                                              required: { value: true },
                                            }}
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col md="6">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor="validationCustom01">
                                            Click & Collect
                                          </Label>
                                          <select
                                            className="form-control"
                                            name="isClickAndCollect"
                                            id="choices-single-no-search"
                                            onChange={(e) => {
                                              setIsClickAndCollect(
                                                e.target.value
                                              );
                                            }}
                                          >
                                            <option value="">Select</option>
                                            <option value={true}>Active</option>
                                            <option value={false}>
                                              InActive
                                            </option>
                                          </select>
                                        </FormGroup>
                                      </Col>
                                      <Col md="6">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor="validationCustom01">
                                            Image
                                          </Label>
                                          <AvField
                                            name="image"
                                            placeholder="Type Something"
                                            type="text"
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col md="6">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor="validationCustom01">
                                            Region
                                          </Label>
                                          <AvField
                                            name="region"
                                            placeholder="Type Something"
                                            type="text"
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col md="6">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor="validationCustom01">
                                            City
                                          </Label>
                                          <AvField
                                            name="city"
                                            placeholder="Type Something"
                                            type="text"
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col md="6">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor="validationCustom01">
                                            Store Url
                                          </Label>
                                          <AvField
                                            name="storeUrlKey"
                                            placeholder="Type Something"
                                            type="text"
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col md="6">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor="validationCustom01">
                                            Show Sales Banner
                                          </Label>
                                          <select
                                            className="form-control"
                                            name="showSalesBanner"
                                            id="choices-single-no-search"
                                            onChange={(e) => {
                                              setShowSalesBanner(
                                                e.target.value
                                              );
                                            }}
                                          >
                                            <option value="">Select</option>
                                            <option value={true}>Active</option>
                                            <option value={false}>
                                              InActive
                                            </option>
                                          </select>
                                        </FormGroup>
                                      </Col>
                                      <Col md="6">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor="validationCustom01">
                                            Offer Banner Position
                                          </Label>
                                          <select
                                            className="form-control"
                                            name="showSalesBanner"
                                            id="choices-single-no-search"
                                            onChange={(e) => {
                                              setShowSalesBannerPosition(
                                                e.target.value
                                              );
                                            }}
                                          >
                                            <option value="">Select</option>
                                            <option value="top">Top</option>
                                            <option value="center">
                                              Center
                                            </option>
                                            <option value="bottom">
                                              Bottom
                                            </option>
                                          </select>
                                        </FormGroup>
                                      </Col>
                                      <Col md="6">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor="validationCustom01">
                                            Book An Appointment
                                          </Label>
                                          <select
                                            className="form-control"
                                            name="showSalesBanner"
                                            id="choices-single-no-search"
                                            onChange={(e) => {
                                              setBookAnAppointment(
                                                e.target.value
                                              );
                                            }}
                                          >
                                            <option value="">Select</option>
                                            <option value={true}>Active</option>
                                            <option value={false}>
                                              InActive
                                            </option>
                                          </select>
                                        </FormGroup>
                                      </Col>
                                      <Col md="6">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor="validationCustom01">
                                            Appointment URL
                                          </Label>
                                          <AvField
                                            name="appointmentURL"
                                            placeholder="Type Something"
                                            type="text"
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col md="6">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor="validationCustom01">
                                            Meta Title(English)
                                          </Label>
                                          <AvField
                                            name="metaTitle_en"
                                            placeholder="Type Something"
                                            type="text"
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col md="6">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor="validationCustom01">
                                            Meta Title(Arabic)
                                          </Label>
                                          <AvField
                                            name="metaTitle_ar"
                                            placeholder="Type Something"
                                            type="text"
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col md="6">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor="validationCustom01">
                                            Meta Description(English)
                                          </Label>
                                          <AvField
                                            name="metaDescription_en"
                                            placeholder="Type Something"
                                            type="text"
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col md="6">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor="validationCustom01">
                                            Meta Description(Arabic)
                                          </Label>
                                          <AvField
                                            name="metaDescription_ar"
                                            placeholder="Type Something"
                                            type="text"
                                          />
                                        </FormGroup>
                                      </Col>
                                    </Row>
                                  </CardBody>
                                </Card>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </Collapse>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingTwo">
                        <button
                          className={classnames(
                            'accordion-button',
                            'fw-medium',
                            { collapsed: !col2 }
                          )}
                          type="button"
                          onClick={t_col2}
                          style={{ cursor: 'pointer' }}
                        >
                          Aditional Information
                        </button>
                      </h2>

                      <Collapse isOpen={col2} className="accordion-collapse">
                        <div className="accordion-body">
                          <div className="text-muted">
                            <Row
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'center',
                              }}
                            >
                              <Col lg={9}>
                                <Card>
                                  <CardBody>
                                    <Row>
                                      <Col lg="6">
                                        <FormGroup className="mb-3">
                                          <label
                                            htmlFor="choices-single-no-search"
                                            className="form-label font-size-13 text-muted"
                                          >
                                            Address - English
                                          </label>
                                          <AvField
                                            name="address_en"
                                            placeholder="Type Something"
                                            type="text"
                                            errorMessage="Please write the Store Address"
                                            validate={{
                                              required: { value: true },
                                            }}
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col lg="6">
                                        <FormGroup className="mb-3">
                                          <label
                                            htmlFor="choices-single-no-search"
                                            className="form-label font-size-13 text-muted"
                                          >
                                            Address - Arabic
                                          </label>
                                          <AvField
                                            name="address_ar"
                                            placeholder="Type Something"
                                            type="text"
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col lg="6">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor="validationCustom01">
                                            Store Timing - English
                                          </Label>
                                          <AvField
                                            name="storeTiming_en"
                                            placeholder="Type Something"
                                            type="text"
                                            validate={{
                                              required: { value: true },
                                            }}
                                          />
                                        </FormGroup>
                                      </Col>

                                      <Col lg="6">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor="validationCustom01">
                                            Store Timing - Arabic
                                          </Label>
                                          <AvField
                                            name="storeTiming_ar"
                                            placeholder="Type Something"
                                            type="text"
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col lg="6">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor="validationCustom01">
                                            Short Description - English
                                          </Label>
                                          <AvField
                                            name="shortDec_en"
                                            placeholder="Type Something"
                                            type="text"
                                            errorMessage="Write Short Description"
                                            validate={{
                                              required: { value: true },
                                            }}
                                          />
                                        </FormGroup>
                                      </Col>
                                      <Col lg="6">
                                        <FormGroup className="mb-3">
                                          <Label htmlFor="validationCustom01">
                                            Short Description - Arabic
                                          </Label>
                                          <AvField
                                            name="storeDec_ar"
                                            placeholder="Type Something"
                                            type="text"
                                            errorMessage="Write Short Description"
                                          />
                                        </FormGroup>
                                      </Col>

                                      <div className="mb-3">
                                        <label>Body* – English</label>
                                        <CustomRichTextEditor
                                          updateDescriptionContent={
                                            updateArticleContentEn
                                          }
                                          data_rtl={false}
                                        />
                                      </div>

                                      <div className="mb-3">
                                        <label>Body* – Arabic</label>
                                        <CustomRichTextEditor
                                          updateDescriptionContent={
                                            updateArticleContentAr
                                          }
                                          data_rtl={false}
                                        />
                                      </div>
                                    </Row>
                                  </CardBody>
                                </Card>
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </Collapse>
                    </div>
                  </div>
                </CardBody>
              </AvForm>
            </Col>
          </Row>
        </Container>
      </div>
      <Toaster position="top-right" reverseOrder={false} />
    </React.Fragment>
  );
};

export default ClickandCollect;
